import { Link } from "react-router-dom";
import { Mouse, Headphones, Monitor, Shirt, Trophy, Backpack } from "lucide-react";
import ScrollReveal from "@/components/3d/ScrollReveal";

const cats = [
  { label: "Peripherals", icon: Mouse, to: "/shop?cat=Peripherals", color: "text-primary" },
  { label: "Audio", icon: Headphones, to: "/shop?cat=Audio", color: "text-accent" },
  { label: "Setup Gear", icon: Monitor, to: "/shop?cat=Setup+Gear", color: "text-glow-red" },
  { label: "Gaming Merch", icon: Shirt, to: "/shop?cat=Gaming+Merch", color: "text-primary" },
  { label: "Collectibles", icon: Trophy, to: "/shop?cat=Collectibles", color: "text-accent" },
  { label: "Accessories", icon: Backpack, to: "/shop?cat=Accessories", color: "text-primary" },
];

const CategoryCards = () => (
  <section className="py-8">
    <div className="container mx-auto px-4">
      <ScrollReveal direction="up">
        <div className="flex gap-3 overflow-x-auto pb-2 scrollbar-hide">
          {cats.map((c) => (
            <Link
              key={c.label}
              to={c.to}
              className="flex shrink-0 flex-col items-center gap-2 rounded-lg border border-border/50 bg-card px-6 py-4 transition-all hover:border-primary/40 hover-glow min-w-[130px]"
            >
              <c.icon className={`h-8 w-8 ${c.color}`} />
              <span className="text-xs font-bold uppercase tracking-wider whitespace-nowrap">{c.label}</span>
            </Link>
          ))}
        </div>
      </ScrollReveal>
    </div>
  </section>
);

export default CategoryCards;
